import React from 'react';
import { prop } from 'ramda';
import { useUserSelector } from '@core/js/store/hooks';
import { componentService } from 'js/services/component.service';

export const CaptainUpBalance = () => {
const cuBalance = useUserSelector(prop('cuBalance'));

  return <span className="captainup-balance">{cuBalance || ''}</span>;
};

componentService.registerWebContentComponents({ CaptainUpBalance });
